import {config} from '../config';

export default {
    getIsICCConsumerServiceEnabled: () => config.data.iccConsumerServices.isICCConsumerServiceEnabled,
    getIsTNCEnabled: () => config.data.iccConsumerServices.isTNCEnabled,
};
